import { axiosInstance, authHeader, handleResponse, handleError } from '../helpers';
import { api } from '../constants'

export const studentService = {
    getStudentList,
    createStudents,
    updateStudents,
    deleteStudent,
    regenerateAccesscode
};

function getStudentList(classid) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return axiosInstance.get(`${api.students.FetchStudents}/${classid}`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error.response));
}

function createStudents(students) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader()
    };

    return axiosInstance.post(api.students.AddStudents, students, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error.response));
}

function updateStudents(students) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader()
    };

    return axiosInstance.put(api.students.updateStudents, students, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error.response));
}

function deleteStudent(classID, studentProfileID) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };

    return axiosInstance.delete(`${api.students.deleteStudent}/${classID}/${studentProfileID}`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error.response));
}

function regenerateAccesscode(studentid) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader()
    };

    return axiosInstance.put(api.students.regenerateAccessCode, studentid, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error.response));
}
